import React from "react";
import Header from "./Header.jsx";
import Hero from "./Hero.jsx";
import Features from "./Features.jsx";
import Works from "./Works.jsx";
import Footer from "./Footer.jsx";

const LandingPage = () => {
  return (
    <div>
      <Header />
      <Hero />
      <Features />
      <Works />
      <Footer />
    </div>
  );
};

export default LandingPage;